
(function () {
  const KLAVIYO_REVISION = "2026-07-15";

  class NotifyMeForm extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.addEventListener("click", this.onClick.bind(this), { signal });
      this.addEventListener("keydown", this.onKeydown.bind(this), { signal });
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    onClick(event) {
      if (!event.target.closest("button")) {
        return;
      }

      event.preventDefault();
      this.submitEmail();
    }

    onKeydown(event) {
      if (event.key !== "Enter" || !event.target.matches('input[type="email"]')) {
        return;
      }

      event.preventDefault();
      this.submitEmail();
    }

    async submitEmail() {
      const emailInput = this.querySelector('input[type="email"]');
      const submitButton = this.querySelector("button");
      const variantId = this.getAttribute("data-variant-id");
      const publicApiKey = window.themeVariables?.settings?.klaviyoPublicApiKey;

      this.hideBanners();

      if (!emailInput || !emailInput.reportValidity()) {
        return;
      }

      if (!variantId || !publicApiKey) {
        this.showBanner("error");
        return;
      }

      submitButton?.setAttribute("disabled", "true");

      try {
        const response = await fetch(
          `https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${encodeURIComponent(publicApiKey)}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/vnd.api+json",
              revision: KLAVIYO_REVISION,
            },
            body: JSON.stringify({
              data: {
                type: "back-in-stock-subscription",
                attributes: {
                  channels: ["EMAIL"],
                  profile: {
                    data: {
                      type: "profile",
                      attributes: { email: emailInput.value },
                    },
                  },
                },
                relationships: {
                  variant: {
                    data: {
                      type: "catalog-variant",
                      id: `$shopify:::$default:::${variantId}`,
                    },
                  },
                },
              },
            }),
          }
        );

        if (!response.ok) {
          throw new Error(`Klaviyo back-in-stock subscription failed with ${response.status}`);
        }

        this.querySelector("[data-notify-me-fields]")?.setAttribute("hidden", "");
        this.showBanner("success");
      } catch (error) {
        submitButton?.removeAttribute("disabled");
        this.showBanner("error");
      }
    }

    showBanner(status) {
      this.querySelector(`[data-notify-me-banner-${status}]`)?.removeAttribute("hidden");
    }

    hideBanners() {
      this.querySelectorAll("[data-notify-me-banner-success], [data-notify-me-banner-error]").forEach((banner) =>
        banner.setAttribute("hidden", "")
      );
    }
  }

  if (!window.customElements.get("notify-me-form")) {
    window.customElements.define("notify-me-form", NotifyMeForm);
  }
})();
